__turbopack_context__.v({
  "accordionBtn": "Footer-module__YYGj3G__accordionBtn",
  "accordionItem": "Footer-module__YYGj3G__accordionItem",
  "accordionLinkWrap": "Footer-module__YYGj3G__accordionLinkWrap",
  "accordionLinks": "Footer-module__YYGj3G__accordionLinks",
  "accordionPanel": "Footer-module__YYGj3G__accordionPanel",
  "accordionWrap": "Footer-module__YYGj3G__accordionWrap",
  "addressBlock": "Footer-module__YYGj3G__addressBlock",
  "awardsWrap": "Footer-module__YYGj3G__awardsWrap",
  "brand": "Footer-module__YYGj3G__brand",
  "brandCol": "Footer-module__YYGj3G__brandCol",
  "callBtn": "Footer-module__YYGj3G__callBtn",
  "callIcon": "Footer-module__YYGj3G__callIcon",
  "chevronOpen": "Footer-module__YYGj3G__chevronOpen",
  "colTitle": "Footer-module__YYGj3G__colTitle",
  "contactCol": "Footer-module__YYGj3G__contactCol",
  "copy": "Footer-module__YYGj3G__copy",
  "desc": "Footer-module__YYGj3G__desc",
  "followUsTitle": "Footer-module__YYGj3G__followUsTitle",
  "footer": "Footer-module__YYGj3G__footer",
  "grid": "Footer-module__YYGj3G__grid",
  "legal": "Footer-module__YYGj3G__legal",
  "legalDivider": "Footer-module__YYGj3G__legalDivider",
  "legalLinks": "Footer-module__YYGj3G__legalLinks",
  "linkList": "Footer-module__YYGj3G__linkList",
  "logo": "Footer-module__YYGj3G__logo",
  "main": "Footer-module__YYGj3G__main",
  "mainBg": "Footer-module__YYGj3G__mainBg",
  "mainBgImg": "Footer-module__YYGj3G__mainBgImg",
  "mainInner": "Footer-module__YYGj3G__mainInner",
  "mainOverlay": "Footer-module__YYGj3G__mainOverlay",
  "officeAddress": "Footer-module__YYGj3G__officeAddress",
  "officeCity": "Footer-module__YYGj3G__officeCity",
  "officesBlock": "Footer-module__YYGj3G__officesBlock",
  "pin": "Footer-module__YYGj3G__pin",
  "pipe": "Footer-module__YYGj3G__pipe",
  "socialBtn": "Footer-module__YYGj3G__socialBtn",
  "socials": "Footer-module__YYGj3G__socials",
  "tagline": "Footer-module__YYGj3G__tagline",
  "tollLabel": "Footer-module__YYGj3G__tollLabel",
});
